import _ from 'lodash';
import validate from '@/helpers/validation';
import { getRightsByEditName } from '../helpers/accessRights';

export default {
  data() {
    return {
      source: null,
      entity: {},
      saveErrorMessage: '',
      ...getRightsByEditName(this.$options.name),
    };
  },

  computed: {
    $_coverUrl() {
      if (!this.source) { return null; }
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    $_coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (_.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
    $_featuredBlocksList() {
      return ['none'].concat(this.$store.state.homeSections);
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {
    $_validate(fields) {
      return validate(fields, this.$_showError);
    },
    $_apadtSource(source) {
      const updatedSource = { ...source };
      if (!Object.prototype.hasOwnProperty.call(updatedSource, 'path_alias')) {
        updatedSource.path_alias = {
          path_alias: '',
        };
      }
      if (!Object.prototype.hasOwnProperty.call(updatedSource, 'featured')) {
        updatedSource.featured = {
          section_id: 0,
          featured_body: '',
        };
      }
      return updatedSource;
    },

    // Funcs for saving
    $_addDefaultFormData() {
      const postFormData = new FormData();
      const references = {
        items: [],
      };
      if (this.entity.loadedReferences && this.entity.loadedReferences.length) {
        references.items = this.entity.loadedReferences.map(item => ({ id: item.id, type: item.type }));
      }
      postFormData.append('published', this.entity.published ? true : '');
      postFormData.append('path_alias', this.entity.path_alias.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      if (Object.prototype.hasOwnProperty.call(this.entity, 'summary')) {
        postFormData.append('summary', this.entity.summary);
      }
      postFormData.append('references', JSON.stringify(references));
      if (this.entity.terms) postFormData.append('terms', JSON.stringify(this.entity.terms.map(item => item.id)));
      return postFormData;
    },
    $_successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    $_errorSave(errorObj) {
      if (_.has(errorObj, 'response.data.errors.path_alias') && errorObj.response.data.errors.path_alias.length) {
        this.$_showError(errorObj.response.data.errors.path_alias[0]);
      } else {
        this.$_showError('Error in data saving');
      }
    },

    // Funcs for validation
    $_showError(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },

    // Funcs for refs and terms
    $_changeRefs(newRefs) {
      this.entity.loadedReferences = newRefs;
    },
    $_changeTerms(newTerms) {
      this.entity.terms = newTerms;
    },

    // Funcs for cover
    $_coverChange(file) {
      this.entity.cover = file;
    },
    $_coverRestore() {
      this.entity.cover = this.source.cover;
    },
    $_coverRemove() {
      this.entity.cover = null;
    },

    // Delete entity
    $_deleteEntity(endpoint) {
      if (window.confirm('Do you really want to delete this entity?')) {
        $(this.$refs.deleteBtnLoader).show();
        this.$apiHttp.delete(this.$config.app_api.prefix + endpoint)
          .then(() => {
            // this.$parent.getSource();
            const newHash = window.location.hash.split('/');
            newHash.pop();
            newHash.pop();
            window.location.hash = newHash.join('/');
            this.$parent.getSource();
          })
          .catch((error) => {
            $(this.$refs.deleteBtnLoader).hide();
            this.$store.dispatch(
              'notifications/setHttpError',
              { error, text: 'Error in deleting entity' },
            );
            console.error(error);
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/EditPageMixin.js